import { RootState } from "@/redux/store";
import { useGetFinancialHealth } from "@/services";
import { useMemo } from "react";
import { useSelector } from "react-redux";

const useFinancialHealth = () => {
  const {communityData, currentFinanceYear} = useSelector(
    (state: RootState) => state.currentData
  );
  
  const {data: financialData, isLoading: isLoadingData} = useGetFinancialHealth({
    communityId: communityData?.communityId,
    fiscalYear: currentFinanceYear
  })

  const ar = useMemo(() => {
    const apiData = financialData?.data;
    return {
      billed: Number(apiData?.ar?.billed ?? 0),
      collected: Number(apiData?.ar?.collected ?? 0),
      outstanding: Number(apiData?.ar?.outstanding ?? 0),
    }
  }, [financialData]);

  const ap = useMemo(() => {
    const apiData = financialData?.data;
    return {
      billed: Number(apiData?.ap?.invoiced ?? 0), 
      collected: Number(apiData?.ap?.payments ?? 0),
      outstanding: Number(apiData?.ap?.outstanding ?? 0),
    }
  }, [financialData]) ;

  return {
    ar,
    ap,
    arOutstanding: ar.outstanding,
    apOutstanding: ap.outstanding,
    isLoadingData,
  };
};

export default useFinancialHealth;